import { render, staticRenderFns } from "./InstallCard.vue?vue&type=template&id=1aab3346&scoped=true"
import script from "./InstallCard.vue?vue&type=script&lang=js"
export * from "./InstallCard.vue?vue&type=script&lang=js"
import style0 from "./InstallCard.vue?vue&type=style&index=0&id=1aab3346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab3346",
  null
  
)

export default component.exports